export enum DapType {
  Simple,
  Composed,
  All
}
